import backendApi from "../api/backendApi";
import { GET_LOCATION } from "../constants/queries/system";

export async function getLocation() {
  const response = await backendApi.post("/", {
    query: GET_LOCATION,
  });
  if (response.data.errors?.length)
    throw new Error(response.data.errors[0].message);

  return response.data.data.getGeoLocation.location;
}
